import { Component, ChangeDetectionStrategy, computed, signal, viewChild } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { ModalDialogComponent } from '@pedix-workspace/angular-ui-modal';
import { IconAlertComponent } from '@pedix-workspace/angular-ui-icons';
import { PurchaseRestrictionKind, PurchaseRestrictionViolation } from '@pedix-workspace/utils';

@Component({
  selector: 'pxw-product-restriction-dialog',
  templateUrl: './product-restriction-dialog.component.html',
  styleUrls: ['./product-restriction-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, ModalDialogComponent, IconAlertComponent],
})
export class ProductRestrictionDialogComponent {
  readonly modalDialog = viewChild.required(ModalDialogComponent);

  readonly restrictedProducts = signal<PurchaseRestrictionViolation[]>([]);
  readonly restrictedProductRows = computed(() => {
    const rows = new Map<string, { productId: string; productName: string; kind: PurchaseRestrictionKind }>();

    for (const violation of this.restrictedProducts()) {
      const row = rows.get(violation.productId);

      rows.set(violation.productId, {
        productId: violation.productId,
        productName: violation.productName,
        kind: row && row.kind !== violation.dimension ? 'both' : violation.dimension,
      });
    }
    return Array.from(rows.values());
  });

  open(restrictedProducts: PurchaseRestrictionViolation[]) {
    this.restrictedProducts.set(restrictedProducts);

    return this.modalDialog().open();
  }
}
